<template>
  <div class="notfound-page">
    <div class="container notfound-inner text-center">
      <div class="nf-heading">
        <h1 class="nf-code">404</h1>
        <h2 class="nf-title">Page Not Found</h2>
      </div>

      <p class="nf-desc">The page you requested does not exist or has been moved.</p>

      <div class="nf-actions">
        <button class="btn btn-primary" @click="goHome">Go to Home</button>
        <button class="btn btn-ghost" @click="goBack">Go Back</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
const router = useRouter();
function goHome() { router.replace({ name: 'Home' }).catch(()=>{}); }
function goBack() { router.back(); }
</script>

<style scoped>
.notfound-page {
  min-height: calc(75vh - 84px);
  display: flex;
  align-items: flex-start; /* push content toward top */
  justify-content: center;
  background: var(--page-bg, #0f2330);
  color: #e6f0f2;
  padding: 6vh 16px; /* provide vertical offset from top */
  box-sizing: border-box;
}

/* container keeps bootstrap-like max-width and centering */
.notfound-inner {
  max-width: 880px;
  width: 100%;
  padding: 8px 20px;
  background: transparent;
  border: none;
  box-shadow: none;
  padding-top: 40px;
}

/* place 404 and Title on the same line and vertically center them */
.nf-heading {
  display: flex;
  align-items: center;   /* vertical center */
  justify-content: center;
  gap: 14px;
  margin-bottom: 12px;
  flex-wrap: wrap;  
}

/* 404 large numeric code */
.nf-code {
  font-size: 64px;
  margin: 0;
  color: #13c2c2;
  font-weight: 800;
  line-height: 1;
}

/* title aligned vertically center with 404 */
.nf-title {
  font-size: 22px;
  margin: 0;
  color: #bfeff0;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}

/* description paragraph */
.nf-desc {
  color: rgba(255,255,255,0.75);
  margin: 14px 0 18px;
  line-height: 1.6;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
}

/* action buttons */
.nf-actions { display:flex; gap:12px; justify-content:center; flex-wrap:wrap; margin-top:6px; padding-top: 28px;}
.btn { padding:10px 18px; border-radius:8px; border:none; cursor:pointer; font-weight:600; }
.btn-primary { background: #13c2c2; color:#081014; }
.btn-ghost { background:transparent; color:#bfeff0; border:1px solid rgba(255,255,255,0.03); }

/* responsive: reduce sizes and allow wrapping on small screens */
@media (max-width: 576px) {
  .nf-heading { gap: 10px; }
  .nf-code { font-size: 48px; }
  .nf-title { font-size: 18px; white-space: normal; }
  .notfound-inner { padding: 8px 12px; }
  .nf-desc { font-size: 0.95rem; padding: 0 6px; }
  .nf-actions { gap: 8px; }
}
</style>